import { Fragment } from 'react'
import { GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import { getStudyTipCategories, getRunningQueriesThunk } from '~/study-tips/apis/studyTips.api'
import Metatags from '~/components/Metadata/Metatags'

import StudyTips from '~/study-tips/pages/StudyTips.page'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

const StudyTipsPage: NextPage = (): React.ReactElement => {
  const { t } = useTranslation('studyTips')
  return (
    <Fragment>
      <Metatags metaDescription={t('shortDescription')} title={usePageTitle(t('title'))} />
      <DefaultLayout zeroPadding>
        <StudyTips />
      </DefaultLayout>
    </Fragment>
  )
}

export const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(getStudyTipCategories.initiate({ language: locale as string }))
    await Promise.all(store.dispatch(getRunningQueriesThunk()))
    return {
      props: {
        namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'studyTips'],
      },
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)

export default StudyTipsPage
